import { Flex, PrimarySecondaryPage, Spinner } from "@wayflyer/flyui";
import type { FundingApplicationSchemas } from "api-types";
import { Suspense } from "react";
import { useIntl } from "react-intl";

import { RevenueSource, RevenueSourceSecondaryContent } from "../../../components";

export const RevenueSourcePage = ({
  air,
  onBack,
}: {
  air: FundingApplicationSchemas.AIRSchema;
  onBack: () => void;
}) => {
  const intl = useIntl();

  return (
    air.air_data && (
      <PrimarySecondaryPage
        titleWrap="wrap"
        title={intl.formatMessage({
          id: "funding-application: air revenue source required title",
          defaultMessage: "Additional eCommerce connection required",
        })}
        primaryContent={
          // Suspense boundary here to prevent parent from mounting (showing sidebar) and this component and hitting suspense in RevenueSource
          <Suspense
            fallback={
              <Flex justify="center" width="100%">
                <Spinner size={32} />
              </Flex>
            }
          >
            <RevenueSource
              publicIdentifier={air.air_data.public_identifier}
              airData={air.air_data.data as FundingApplicationSchemas.AdditionalRevenueSourceAIRSchema}
              onBack={onBack}
            />
          </Suspense>
        }
        secondaryContent={<RevenueSourceSecondaryContent />}
      />
    )
  );
};
